import { render, staticRenderFns } from "./onlineCustomer.vue?vue&type=template&id=19a6a3b0&scoped=true"
import script from "./onlineCustomer.vue?vue&type=script&lang=js"
export * from "./onlineCustomer.vue?vue&type=script&lang=js"
import style0 from "./onlineCustomer.vue?vue&type=style&index=0&id=19a6a3b0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19a6a3b0",
  null
  
)

export default component.exports